import { TimeManager } from "../Utils/Time/TimeManager";
import { Timer } from "../Utils/Time/Timer";
import { eGameAPI, Game } from "../Game";
import { GameWorld } from "./Game World/GameWorld";
import { Player } from "./Game World/Player/Player";
import { eHUDState, HUD } from "./Game World/HUD/HUD";
import { SoundManager } from "../Utils/SoundManager";
import { PwuManager } from "./Powerups/PwuManager";
import { BloomPFx } from "../Utils/Post Effects/Bloom";
import { View } from "./Game World/View/View";
import * as Gamee from "../SDK/Gamee/GameeWrapper";
import { eAdMode, eAdState } from "../SDK/SDKBase";



export const TIME: TimeManager = new TimeManager();
export const TIMER: Timer = TIME.createTimer();



export const enum eState {
    waitForStart,
    ad,
    started,
    keepPlaying,
    gameOver
}



export const enum eBatchGroup {
    solid_0,
    solid_1,
    fakeShadows,
    popupMessages,
}



export class Gameplay {
    static readonly BATCH_GROUP_NAME: string[] = [
        "solid_0",
        "solid_1",
        "fakeShadows",
        "popupMessages"
    ];

    static BATCH_GROUP_ID: number[] = [];

    /**
     * Staticky pristup
     */
    static get instance(): Gameplay { return Gameplay._instance; }
    private static _instance: Gameplay;

    /**
     * (RO) Spravce udalosti
     */
    get events(): pc.EventHandler { return this._events; }
    private _events: pc.EventHandler;

    /**
     * (RO) Aktualni stav
     */
    get state(): eState { return this._state; }
    private _state: eState;

    private _gameWorld: GameWorld;
    private _hud: HUD;
    private _powerups: PwuManager;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        let app = Game.app;

        // Staticky pristup
        Gameplay._instance = this;

        // Spravce udalosti
        this._events = new pc.EventHandler();

        // Svetlo
        let light = new pc.Entity("light");

        light.addComponent(pc.eCompomentType.light, {
            type: pc.LIGHTTYPE_DIRECTIONAL,
            intensity: 0.9,
            isStatic: true,

            bake: false,
            affectDynamic: true,
            affectLightmapped: false,

            castShadows: false,
        });

        light.setEulerAngles(10, 0, 0);
        light.light.color = new pc.Color(1, 0.8, 0.8);
        app.root.addChild(light);

        app.scene.ambientLight.set(0.5, 0.3, 0.3);
        app.scene.gammaCorrection = pc.GAMMA_SRGBFAST;

        // Batchgroups
        Gameplay.BATCH_GROUP_NAME.forEach((name: string) => {
            Gameplay.BATCH_GROUP_ID.push(Game.app.batcher.addGroup(name, true, 100).id);
        });

        // Herni svet
        this._gameWorld = new GameWorld();

        // HUD
        this._hud = new HUD();

        // Powerups
        this._powerups = new PwuManager();

        // Udalosti
        this._events.on(Player.EVENT_DEATH, this.handlePlayerDeath, this);
        //this._events.on(KeepPlaying.EVENT_COMPLETE, this.handleKeepPlayingComplete, this);

        // Bloom post effect
        let bloom = new BloomPFx(app.graphicsDevice, View.instance.camera.camera, 4, 0.25);

        bloom.start({
            bloomIntensity: 1.4,
            bloomThreshold: 0.25,
            blurAmount: 2
        });

        // GAMEE
        if (Game.API == eGameAPI.GAMEE) {
            this._state = eState.waitForStart;

            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, () => {
                let prevState = this._state;

                this._state = eState.started;

                if (prevState != eState.waitForStart)
                    this.reset();
            }, this);

            Gamee.Wrapper.EVENTS.on(Gamee.eEvent.useExtraLife, () => {
                // Restart hry z checkpointu
                this.reset(Player.instance.checkpoint.valid);
            }, this);
        }

        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(deltaS: number): void {
        if (this._state != eState.started)
            return;

        TIME.update(deltaS);

        this._gameWorld.update();
        this._powerups.update();
        this._hud.update();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(restartFromCP: boolean = false): void {
        TIMER.start();

        this._gameWorld.reset(restartFromCP);
        this._hud.setState(eHUDState.tutorial);
        this._powerups.reset();

        if (Game.API == eGameAPI.GAMEE) {
            if (!restartFromCP)
                Game.missions.resetMissionProgress();
        }
        else {
            this._state = eState.started;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handlePlayerDeath(): void {
        // Zastavit zvuky
        SoundManager.stop();

        this._state = eState.gameOver;

        if (Game.API == eGameAPI.GAMEE) {
            Gamee.Wrapper.gameOver();
        }
        else {
            this._hud.setState(eHUDState.gameOver);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    /*private handleKeepPlayingComplete(res: boolean): void {
        if (res) {
            // Restart hry od posledniho checkpointu
            this.reset(true);
        }
        else {
            // GameOver
            this._state = eState.gameOver;
            Gamee.Wrapper.gameOver();
        }
    }*/
}